module.exports = __webpack_public_path__ + "static/media/kid-smiling.1c852f12.jpg";